<svg
  width="16px"
  height="16px"
  viewBox="0 0 16 16"
  version="1.1"
  xmlns="http://www.w3.org/2000/svg"
  xmlns:xlink="http://www.w3.org/1999/xlink"
>
  <!-- Generator: Sketch 47.1 (45422) - http://www.bohemiancoding.com/sketch -->
  <title>np_chose_948101_000000@3x</title>
  <desc>Created with Sketch.</desc>
  <defs></defs>
  <g id="Working-File" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
    <g id="Default" transform="translate(-246.000000, -462.000000)" fill-rule="nonzero" fill="#2589BC">
      <g id="Group-15" transform="translate(246.000000, 423.000000)">
        <g id="np_chose_948101_000000" transform="translate(0.000000, 39.000000)">
          <path
            d="M8,0.1876 C3.6922,0.1876 0.1876,3.6922 0.1876,8 C0.1876,12.3078 3.6922,15.8124 8,15.8124 C12.3078,15.8124 15.8124,12.3078 15.8124,8 C15.8124,3.6922 12.3078,0.1876 8,0.1876 Z M8,15.1876 C4.0368,15.1876 0.8124,11.9634 0.8124,8 C0.8124,4.0366 4.0366,0.8124 8,0.8124 C11.9634,0.8124 15.1876,4.0366 15.1876,8 C15.1876,11.9634 11.9634,15.1876 8,15.1876 Z"
            id="Shape"
          ></path>
          <path
            d="M11.2648,3.9704 C11.110112,3.893056 10.92262,3.9555564 10.84526,4.110244 L7.28906,11.222644 L5.09526,9.028844 C4.973386,8.906968 4.77572,8.906968 4.65308,9.028844 C4.531204,9.15072 4.531204,9.348384 4.65308,9.471024 L7.15308,11.971024 C7.212456,12.029618 7.292142,12.06243 7.37496,12.06243 C7.3913662,12.06243 7.408554,12.0608676 7.42496,12.0585238 C7.524178,12.0421176 7.609336,11.9796178 7.65464,11.8897738 L11.40464,4.3897738 C11.481984,4.2350858 11.4187024,4.0475938 11.264796,3.9702338 L11.2648,3.9704 Z"
            id="Shape"
          ></path>
        </g>
      </g>
    </g>
  </g>
</svg>
